import { createRouter, createWebHistory } from "vue-router";

import Login from "./components/Login.vue"
import Maintenance from "./components/Maintenance.vue"
import Menu from "./components/Menu.vue"
import Menu2 from "./components/Menu2.vue"
import Product from "./components/Product.vue"
import SearchActivation from "./components/SearchActivation.vue"
import GenerateActivation from "./components/GenerateActivation.vue"
import ActivationCodeList from "./components/ActivationCodeList.vue"
import VersionChecker from "./components/VersionChecker.vue"
import FirmwareUpdate from "./components/FirmwareUpdate.vue"
import Model from "./components/Model.vue"

const routes = [
    {
	path: "/index.html",
	name: "Login",
	component: Login,
	meta: {
	    title: 'Login'
	}
    },
    {
	path: "/maintenance.html",
	name: "Maintenance",
	component: Maintenance,
	meta: {
	    title: 'Maintenance'
	}
    },
    {
	path: "/menu.html",
	name: "Menu",
	component: Menu,
	meta: {
	    title: 'Menu'
	}
    },
    {
	path: "/menu2.html",
	name: "Menu2",
	component: Menu2,
	meta: {
	    title: 'Menu2'
	}
    },
    {
	path: "/product.html",
	name: "Product",
	component: Product,
	meta: {
	    title: 'Product'
	}
    },
    {
	path: "/searchactivation.html",
	name: "SearchActivation",
	component: SearchActivation,
	meta: {
	    title: 'Search Activation'
	}
    },
    {
	path: "/generateactivation.html",
	name: "GenerateActivation",
	component: GenerateActivation,
	meta: {
	    title: 'Generate Activation'
	}
    },
    {
	path: "/activationcodelist.html",
	name: "ActivationCodeList",
	component: ActivationCodeList,
	meta: {
	    title: 'Activation Code List'
	}
    },
    {
	path: "/versionchecker.html",
	name: "VersionChecker",
	component: VersionChecker,
	meta: {
	    title: 'Version Checker'
	}
    },
    {
	path: "/firmwareupdate.html",
	name: "FirmwareUpdate",
	component: FirmwareUpdate,
	meta: {
	    title: 'Firmware Update'
	}
    },
    {
	path: "/model.html",
	name: "Model",
	component: Model,
	meta: {
	    title: 'Model'
	}
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
});

export default router;
